import React, {useContext, useEffect, useState} from 'react';
import DivisionServiceAPI from "../../services/api/divisionApi";
import DockyardListItem from "./DockyardListItem";
import HeaderNav from "../_common/HeaderNav";
import {MapContext} from "../../context/MapContext";
import {useHistory} from "react-router-dom";
import LoaderSpinner from "../_common/Loader";
import DockyardsServiceAPI from "../../services/api/dockyardApi";

const DockyardList = (props) => {
    const {id} = props.match.params || null;
    const [progress, setProgress] = useState(false)
    const [divisionData, setDivisionData] = useState(null)
    const [searchText, setSearchText] = useState('')
    const [searchDockyards, setSearchDockyards] = useState(null)
    const [offlineUnavailableData, setOfflineUnavailableData] = useState({})
    const {dispatch} = useContext(MapContext);
    const history = useHistory();

    useEffect(() => {
        try {
            setProgress(true);
            let data;
            const timeout = setTimeout(() => {
                (async () => {
                    let divisionData = await DivisionServiceAPI.getDivisionDetailsById(id);
                    divisionData && 'data' in divisionData && setDivisionData(divisionData.data[0].json_data)
                    setProgress(false);
                })();
            }, 500);
            return () => {
                clearTimeout(timeout);
                if (data) {
                    data();
                }
            };
        } catch (e) {
            console.log(e)
            setProgress(false);
        }
    }, []);

    const selectDockyard = async (dockyard) => {
        try {
            if (dockyard) {
                let dockyardData = await DockyardsServiceAPI.getDockyardDetailsById(dockyard.id) || {}
                if (dockyardData && !dockyardData.error && dockyardData.data && dockyardData.data.length) {
                    dispatch({type: 'SELECT_DOCKYARD', dockyardData: dockyardData.data[0].json_data});
                    history.push('/carte')
                } else {
                    !navigator.onLine && setOfflineUnavailableData({...offlineUnavailableData, [dockyard.id]: true})
                }
            }
        } catch (e) {
            !navigator.onLine && setOfflineUnavailableData({...offlineUnavailableData, data: [dockyard.id]})
            console.log(e)
        }
    }

    useEffect(() => {
        let results = (divisionData && divisionData.dockyards) || null;
        if (searchText !== '' && results) {
            results = divisionData.dockyards.filter(dockyard => {
                return dockyard &&
                    (dockyard.name.toLowerCase().search(searchText.toLowerCase()) !== -1 ||
                        dockyard.reference.toLowerCase()
                            .replace(/\s+/g, "")
                            .search(searchText.toLowerCase()) !== -1);
            });
        }
        setSearchDockyards(results);
    }, [searchText, divisionData]);

    /*Reset offline data availabilities*/
    window.addEventListener('online', () => {
        setOfflineUnavailableData({})
    })

    return (
        <div className="container-fluid" id={'container-heading'}>
            <HeaderNav
                title={divisionData && (divisionData.name || 'Agence non trouvée')}
                backToDo={() => history.push('/')}
                searchElement={{searchText, setSearchText}}
            />
            <div className={`container-data ${progress && 'loader'}`}>
                {
                    progress ?
                        <LoaderSpinner/>
                        :
                        searchDockyards ?
                            searchDockyards.length <= 0 ?
                                <div className={'row justify-content-center w-100 m-0'}>
                                    <div className={'col-12 text-center'}>
                                        <i className="fas fa-exclamation-triangle big-icon-colored"/>
                                    </div>
                                    <div className={'col-12 my-2'}>
                                        <p className={'global-text-center'}>
                                            Aucun résultat correspondant.
                                        </p>
                                    </div>
                                </div>
                                :
                                searchDockyards
                                    .filter(dockyard => dockyard.count_area && dockyard.count_area >= 0)
                                    .sort((a, b) => a.name.localeCompare(b.name))
                                    .map((dockyard, index) => {
                                        return (
                                            <div className={'row w-100 m-0'} key={index}
                                                 onClick={() => selectDockyard(dockyard)}>
                                                <DockyardListItem
                                                    dockyardData={dockyard}
                                                    dataUnavailable={
                                                        offlineUnavailableData && offlineUnavailableData[dockyard.id]
                                                    }
                                                />
                                            </div>
                                        )
                                    })
                            :
                            <div className={'row justify-content-center w-100 m-0'}>
                                <div className={'col-12 text-center'}>
                                    <i className="fas fa-exclamation-triangle big-icon-colored"/>
                                </div>
                                <div className={'col-12 my-2'}>
                                    <p className={'global-text-center'}>
                                        Aucun chantier disponible pour cette agence.
                                    </p>
                                </div>
                            </div>
                }
            </div>
        </div>
    );
};

export default DockyardList;